export enum ShareType {
    EMAIL = 'email',
    FACEBOOK = 'facebook',
    LINKEDIN = 'linkedin',
    TWITTER = 'twitter',
    COPY_LINK = 'copy_link',
    GMAIL = 'gmail',
}
